import { Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-copiable-info',
  templateUrl: './copiable-info.component.html',
  styleUrls: ['./copiable-info.component.scss'],
  imports: [MatIconModule, MatTooltipModule, MatSnackBarModule]
})
export class CopiableInfoComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() value?: string = '';

  constructor(private snackBar: MatSnackBar) { }


  copyToClipboard() {
    if (this.value) {
      navigator.clipboard.writeText(this.value);
      this.snackBar.open('Copied !', 'close',{
        duration: 2000,
      });
    }
  }
}
